import { FC } from 'react';

type CyberRiskAssessmentProps = {
  width?: string;
  color?: string;
};

export const CyberRiskAssessment: FC<CyberRiskAssessmentProps> = ({
  width,
  color,
}) => (
  <svg
    role="img"
    width={width ?? '24'}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 9C15 9.55228 14.5523 10 14 10H13V8H14C14.5523 8 15 8.44772 15 9Z"
      fill={color ?? 'currentColor'}
    />
    <path
      d="M19 8C18.4477 8 18 8.44771 18 9V10H20V9C20 8.44771 19.5523 8 19 8Z"
      fill={color ?? 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4C6 2.89543 6.89543 2 8 2H20C21.1046 2 22 2.89543 22 4V16C22 17.1046 21.1046 18 20 18H8C6.89543 18 6 17.1046 6 16V4ZM11 7H9C7.89543 7 7 7.89543 7 9V11C7 12.1046 7.89543 13 9 13H11V12H9C8.44771 12 8 11.5523 8 11V9C8 8.44771 8.44772 8 9 8H11V7ZM12 7H14C15.1046 7 16 7.89543 16 9C16 9.59735 15.7381 10.1335 15.3229 10.5C15.7381 10.8665 16 11.4027 16 12V13H15V12C15 11.4477 14.5523 11 14 11H13V13H12V7ZM19 7C20.1046 7 21 7.89543 21 9V13H20V11H18V13H17V9C17 7.89543 17.8954 7 19 7Z"
      fill={color ?? 'currentColor'}
    />
    <path
      d="M2 6H4V20H18V22H4C2.89543 22 2 21.1046 2 20V6Z"
      fill={color ?? 'currentColor'}
    />
  </svg>
);
